// lib/api.js
// Central API base + a lightweight "warm-up" ping.
//
// Why: the backend runs on Render's free tier, which sleeps after inactivity.
// The first request to a sleeping instance can take ~10-20s, so a visitor who
// submits the contact form cold would wait. To avoid that, we fire a cheap
// GET /api/health in the background on page load and on early signs of intent
// (hovering the Contact button, opening the contact page). By the time they
// actually submit, the instance should already be awake.

// Prefer the Vercel-configured value; fall back to the Render API so requests
// still work if REACT_APP_API_BASE_URL is missing in the build environment.
export const API_BASE =
  process.env.REACT_APP_API_BASE_URL || "https://triggerflow-server.onrender.com";

if (process.env.NODE_ENV === "development" && !process.env.REACT_APP_API_BASE_URL) {
  console.warn(
    "[TriggerFlow] REACT_APP_API_BASE_URL is not set — falling back to the live Render API.\n" +
    "Set it in client/.env.local to target your local server (e.g. http://localhost:5000)."
  );
}

let lastWarmAt = 0;
const WARM_INTERVAL_MS = 60_000; // don't re-ping more than once a minute

// Fire-and-forget ping to wake a sleeping backend.
// Safe to call repeatedly (page load, hover, focus) — it self-throttles and
// never throws or surfaces errors to the user.
export function warmUpApi() {
  if (typeof fetch !== "function") return;

  const now = Date.now();
  if (now - lastWarmAt < WARM_INTERVAL_MS) return;
  lastWarmAt = now;

  try {
    fetch(`${API_BASE}/api/health`, {
      method: "GET",
      mode: "cors",
      cache: "no-store",
      keepalive: true,
    }).catch(() => {}); // best-effort; ignore failures
  } catch (_) {
    // ignore — warming should never break the page
  }
}
